import { redirect } from "@tanstack/react-router";
import { useOrgStore } from "@/stores";
import {
  DEFAULT_ENABLED_FEATURES,
  type FeatureCode,
} from "@/features/system-admin/constants/features";

const DEFAULT_FEATURES: FeatureCode[] = [...DEFAULT_ENABLED_FEATURES];

const FEATURE_ROUTE_PREFIXES: Array<{ prefix: string; feature: FeatureCode }> = [
  { prefix: "/knowledges", feature: "knowledge_base" },
  { prefix: "/tags", feature: "knowledge_base" },
  { prefix: "/categories", feature: "knowledge_base" },
  { prefix: "/kg-graph", feature: "kg" },
  { prefix: "/workflows", feature: "workflows" },
  { prefix: "/checkpoints", feature: "workflows" },
];

export function getEnabledFeatures(): FeatureCode[] {
  const currentOrg = useOrgStore.getState().currentOrg;
  if (!currentOrg) return [];
  return currentOrg.enabledFeatures ?? DEFAULT_FEATURES;
}

export function isFeatureEnabled(code: FeatureCode): boolean {
  return getEnabledFeatures().includes(code);
}

export function requireFeatureEnabled(code: FeatureCode): void {
  const currentOrg = useOrgStore.getState().currentOrg;
  if (!currentOrg) {
    return;
  }

  if (!getEnabledFeatures().includes(code)) {
    throw redirect({
      to: "/feature-disabled/$code",
      params: { code },
      replace: true,
    });
  }
}

export function getDisabledFeatureForPath(
  pathname: string,
  enabledFeatures: readonly FeatureCode[],
): FeatureCode | null {
  for (const { prefix, feature } of FEATURE_ROUTE_PREFIXES) {
    if (pathname === prefix || pathname.startsWith(`${prefix}/`)) {
      return enabledFeatures.includes(feature) ? null : feature;
    }
  }
  return null;
}
